import { z } from 'zod';
import { moneyAmountSchema } from './expense.js';
import { isIsoDay } from '../utils/checklist.js';
const isoDay = z.string().refine(isIsoDay, 'Expected a real calendar day, YYYY-MM-DD');
// ─── A template item's tasks ────────────────────────────────────────────────
export const templateItemTaskSchema = z.object({
    title: z.string().trim().min(1).max(500),
    dueDateOffsetDays: z.number().int().min(-3650).max(3650).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
export const templateItemTasksSchema = z.array(templateItemTaskSchema).max(50);
/** A unit is a value of the `item_units` Settings list; blank is none. */
const unitSchema = z
    .string()
    .trim()
    .max(64)
    .nullable()
    .optional()
    .transform((v) => (v === '' ? null : v));
// ─── Planning Item ──────────────────────────────────────────────────────────
export const createPlanningItemSchema = z.object({
    vendorCategoryId: z.string().uuid().nullable().optional(),
    catalogItemId: z.string().uuid().nullable().optional(),
    itemName: z.string().max(500).optional(),
    quantity: moneyAmountSchema.optional(),
    roomId: z.string().uuid().nullable().optional(),
    expenseItemId: z.string().uuid().nullable().optional(),
    templateNeedKey: z.string().trim().min(1).max(64).nullable().optional(),
    // Never negative, within Decimal(12, 2), whole cents (it used to overflow to a 500).
    unitPrice: moneyAmountSchema.optional(),
    unit: unitSchema,
    notes: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
    templateTasks: templateItemTasksSchema.nullable().optional(),
});
export const updatePlanningItemSchema = z.object({
    vendorCategoryId: z.string().uuid().nullable().optional(),
    catalogItemId: z.string().uuid().nullable().optional(),
    itemName: z.string().max(500).nullable().optional(),
    quantity: moneyAmountSchema.optional(),
    roomId: z.string().uuid().nullable().optional(),
    expenseItemId: z.string().uuid().nullable().optional(),
    // Never negative, within Decimal(12, 2), whole cents (it used to overflow to a 500).
    unitPrice: moneyAmountSchema.optional(),
    unit: unitSchema,
    notes: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
    templateTasks: templateItemTasksSchema.nullable().optional(),
});
/** At most a sheet's worth at a time: a paste is a few hundred rows, not more. */
export const bulkCreatePlanningItemsSchema = z.object({
    items: z.array(createPlanningItemSchema).min(1).max(500),
});
export const reorderPlanningItemsSchema = z.object({
    itemIds: z.array(z.string().uuid()).min(1).max(5000),
});
export const createItemTaskSchema = z.object({
    title: z.string().trim().min(1).max(500),
    dueDate: isoDay.nullable().optional(),
    assignedToUserId: z.string().uuid().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
// ─── Planning List ──────────────────────────────────────────────────────────
export const createPlanningListSchema = z.object({
    eventId: z.string().uuid().optional(),
    eventTypeId: z.string().uuid().optional(),
    isTemplate: z.boolean().optional(),
    templateName: z.string().max(255).optional(),
    title: z.string().max(500).optional(),
    description: z.string().max(2000).optional(),
    items: z.array(createPlanningItemSchema).optional(),
});
export const updatePlanningListSchema = z.object({
    title: z.string().max(500).nullable().optional(),
    templateName: z.string().max(255).nullable().optional(),
    description: z.string().max(2000).nullable().optional(),
    eventTypeId: z.string().uuid().nullable().optional(),
});
export const clonePlanningListSchema = z.object({
    eventId: z.string().uuid().optional(),
    title: z.string().max(500).optional(),
});
export const savePlanningListAsTemplateSchema = z.object({
    templateName: z.string().min(1).max(255),
    eventTypeId: z.string().uuid().optional(),
});
//# sourceMappingURL=planning.js.map